import { CheckCircle2, XCircle, Home, Sparkles } from "lucide-react";

export const MaidVsHouseCleaningInfographic = () => {
  return (
    <div className="my-12 p-6 md:p-8 bg-card rounded-2xl border shadow-sm">
      <div className="text-center mb-8">
        <h3 className="text-2xl md:text-3xl font-bold mb-3">Maid Service vs House Cleaning</h3>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          While often used interchangeably, these services traditionally have different focuses. Here is a breakdown of what to expect.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="p-6 bg-muted/30 rounded-xl border">
          <div className="flex items-center gap-4 mb-6 pb-4 border-b">
            <div className="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center">
              <Sparkles className="h-6 w-6" />
            </div>
            <div>
              <h4 className="font-bold text-xl">Maid Service</h4>
              <p className="text-sm text-muted-foreground">Daily/Weekly Upkeep</p>
            </div>
          </div>
          
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Light tidying and organizing</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Making beds and changing linens</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Loading and unloading the dishwasher</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Doing laundry and folding clothes</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Taking out daily trash</span>
            </li>
            <li className="flex items-start gap-3 text-muted-foreground">
              <XCircle className="h-5 w-5 shrink-0 mt-0.5" />
              <span>Deep scrubbing of buildup</span>
            </li>
          </ul>
        </div>

        <div className="p-6 bg-primary/5 rounded-xl border border-primary/20">
          <div className="flex items-center gap-4 mb-6 pb-4 border-b border-primary/20">
            <div className="w-12 h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center">
              <Home className="h-6 w-6" />
            </div>
            <div>
              <h4 className="font-bold text-xl text-primary">House Cleaning</h4>
              <p className="text-sm text-muted-foreground">Thorough Sanitization</p>
            </div>
          </div>
          
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Deep scrubbing of bathrooms and kitchens</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Mopping, vacuuming, and floor care</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Removing hard water stains and grease</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>Dusting ceiling fans, baseboards, and blinds</span>
            </li>
            <li className="flex items-start gap-3 text-muted-foreground">
              <XCircle className="h-5 w-5 shrink-0 mt-0.5" />
              <span>Organizing personal clutter</span>
            </li>
            <li className="flex items-start gap-3 text-muted-foreground">
              <XCircle className="h-5 w-5 shrink-0 mt-0.5" />
              <span>Folding laundry or doing dishes</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center bg-muted p-4 rounded-lg">
        <p className="text-sm font-medium">
          <strong>Note:</strong> At Uplevel Cleaning, we offer comprehensive house cleaning services, but many add-ons (like laundry or dishes) can be requested to create a hybrid experience tailored to your needs.
        </p>
      </div>
    </div>
  );
};
